/*
 * ORIMONO wishlist feedback (Robin 22 Oct, option C):
 * when a visitor adds a product to the wishlist, a filled heart flies from the tapped heart to the
 * wishlist icon in the header (which pulses), then a wishlist preview slides in from the right,
 * built like the cart preview: the saved product + "View wishlist" / "Continue shopping".
 * Removing from the wishlist only updates the hearts (no animation, no preview).
 * Reduced motion: no flight, the preview still opens.
 * Listens to om-wishlist.js ('om:wishlist:change'); it never changes the wishlist itself.
 */
(function () {
  'use strict';
  if (window.omWishlistFx) return;
  window.omWishlistFx = true;

  var SEL = '.swym-add-to-wishlist-view-product, [data-om-wishlist]';
  /* product cards only (not .grid__item: on the product page the info column is a .grid__item too) */
  var CARD_SEL = '.boost-sd__product-item, .new-product-i-item, .product-card-wrapper, .card-wrapper, .swiper-slide, .lmn-card';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s-7.5-4.6-9.6-9.2C1 8.6 3 5 6.6 5c2.1 0 3.6 1.2 4.4 2.6h2C13.8 6.2 15.3 5 17.4 5 21 5 23 8.6 21.6 11.8 19.5 16.4 12 21 12 21z"/></svg>';
  var T = {
    en: ['Wishlist', 'View wishlist', 'Continue shopping', 'Saved to your wishlist.', 'Close'],
    de: ['Wunschliste', 'Wunschliste ansehen', 'Weiter einkaufen', 'Auf deiner Wunschliste gespeichert.', 'Schließen'],
    fr: ['Liste de souhaits', 'Voir la liste', 'Continuer mes achats', 'Ajouté à votre liste de souhaits.', 'Fermer'],
    it: ['Lista dei desideri', 'Vedi la lista', 'Continua lo shopping', 'Salvato nella tua lista dei desideri.', 'Chiudi'],
    es: ['Lista de deseos', 'Ver lista', 'Seguir comprando', 'Guardado en tu lista de deseos.', 'Cerrar'],
    ja: ['ウィッシュリスト', 'ウィッシュリストを見る', '買い物を続ける', 'ウィッシュリストに保存しました。', '閉じる'],
    ko: ['위시리스트', '위시리스트 보기', '쇼핑 계속하기', '위시리스트에 저장되었습니다.', '닫기'],
    zh: ['心愿单', '查看心愿单', '继续购物', '已保存到心愿单。', '关闭']
  };
  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var t = T[lang] || T.en;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var wishlistUrl = root.replace(/\/$/, '') + '/pages/swym-wishlist';

  /* remember which heart was pressed (om-wishlist.js stops the click itself, so use pointerdown/keydown) */
  var last = { btn: null, at: 0 };
  function remember(e) {
    var b = e.target && e.target.closest && e.target.closest(SEL);
    if (b) { last.btn = b; last.at = Date.now(); }
  }
  window.addEventListener('pointerdown', remember, true);
  window.addEventListener('touchstart', remember, { capture: true, passive: true });
  window.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') remember(e); }, true);

  var prevCount = null;
  function countNow() { return window.omWishlist ? window.omWishlist.count() : 0; }

  document.addEventListener('om:wishlist:change', function (e) {
    var d = e.detail || {};
    var n = (d.items || []).length;
    var grew = prevCount !== null && n > prevCount;
    prevCount = n;
    if (!grew || d.source !== 'local') return;
    if (/\/pages\/(swym-)?wishlist/.test(location.pathname)) return; /* on the wishlist page itself */
    var item = (d.items || [])[0];
    if (!item) return;
    var btn = last.btn && Date.now() - last.at < 4000 ? last.btn : null;
    last.btn = null;
    if (!btn) { openDrawer(item, { price: '', img: '' }, n); return; }
    var info = infoFrom(btn);
    fly(btn, function () { openDrawer(item, info, n); });
  });

  function start() { prevCount = countNow(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { if (prevCount === null) prevCount = countNow(); });

  /* ---------------- flight ---------------- */
  function visibleHeaderHeart() {
    var list = document.querySelectorAll('.header-wishlist-icon');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return list[i];
    }
    return null;
  }
  function bump(el, s) {
    if (!el || !el.animate || reduce.matches) return;
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(' + s + ')' }, { transform: 'scale(1)' }], { duration: 340, easing: 'cubic-bezier(.3,1.6,.5,1)' });
  }
  /* the header hides while scrolling down: bring it back first, so there is an icon to fly to */
  function withHeaderIcon(find, cb) {
    if (reduce.matches || !document.body.animate) { cb(null); return; }
    var t = find();
    if (t) { cb(t); return; }
    // ORIMONO header hides on scroll-down via body.full-header-sticky (sections/header.liquid);
    // drop it so the header slides back in; the next scroll-down re-adds it.
    var hid = document.body.classList.contains('full-header-sticky');
    if (hid) document.body.classList.remove('full-header-sticky');
    var sh = document.querySelector('sticky-header');
    if (sh && typeof sh.reveal === 'function') { try { sh.reveal(); } catch (e) {} }
    if (!hid && !(sh && sh.reveal)) { cb(null); return; }
    setTimeout(function () { cb(find()); }, 420);
  }
  function fly(btn, done) {
    withHeaderIcon(visibleHeaderHeart, function (target) { flyHeart(btn, target, done); });
  }
  function flyHeart(btn, target, done) {
    var src = (btn.querySelector('svg') || btn).getBoundingClientRect();
    if (!target || src.width === 0) { done(); return; }
    var dst = target.getBoundingClientRect();
    var size = 22;
    var f = document.createElement('div');
    f.className = 'om-wl-fly';
    f.innerHTML = HEART;
    f.style.left = (src.left + src.width / 2 - size / 2) + 'px';
    f.style.top = (src.top + src.height / 2 - size / 2) + 'px';
    document.body.appendChild(f);
    var dx = (dst.left + dst.width / 2) - (src.left + src.width / 2);
    var dy = (dst.top + dst.height / 2) - (src.top + src.height / 2);
    var anim = f.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.35 + 'px,' + (dy * 0.45 - 70) + 'px) scale(1.5)', opacity: 1, offset: 0.4 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.55)', opacity: 0.9 }
    ], { duration: 700, easing: 'cubic-bezier(.45,0,.25,1)' });
    var finished = false;
    function end() {
      if (finished) return;
      finished = true;
      f.remove();
      bump(target, 1.35);
      setTimeout(done, 120);
    }
    anim.onfinish = end;
    setTimeout(end, 1200); /* safety if the animation is interrupted */
  }

  /* ---------------- product details for the preview ---------------- */
  function infoFrom(btn) {
    var card = btn.classList.contains('om-wl-pdp') ? null : btn.closest(CARD_SEL);
    var priceEl = card
      ? card.querySelector('.new-pro-i-price, .boost-sd__product-price, .price')
      : ((btn.closest('.shopify-section') || document).querySelector('.price-wrapper .lm-price, .price-wrapper, .lm-price, .price-item'));
    var price = priceEl ? priceEl.innerText.replace(/\s+/g, ' ').trim() : '';
    var img = card ? card.querySelector('img') : largestImage();
    return { price: price, img: img ? (img.currentSrc || img.src) : '' };
  }
  /* product page: the main product photo = the largest picture on screen */
  function largestImage() {
    var main = document.querySelector('.main-image-media img');
    if (main && main.getBoundingClientRect().width > 0) return main;
    var best = null, area = 0;
    document.querySelectorAll('main img, .product img').forEach(function (im) {
      if (im.closest('.product-zoomed-img')) return; /* hidden zoom layer */
      var r = im.getBoundingClientRect();
      var a = r.width * r.height;
      if (a > area && r.width > 120) { area = a; best = im; }
    });
    return best;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------------- drawer ---------------- */
  var drawer;
  function ensureDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'site-drawer om-wl-drawer';
    drawer.id = 'omWishlistDrawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'omWlDrawerTitle');
    drawer.innerHTML =
      '<div class="site-drawer-heading-wrap">' +
        '<div class="site-drawer-heading" id="omWlDrawerTitle"></div>' +
        '<button class="site-drawer-close" type="button" data-drawer-close aria-label="' + esc(t[4]) + '">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none"><path d="M2 2L17 16" stroke="black" stroke-width="3"/><path d="M2 16L17 2" stroke="black" stroke-width="3"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="site-drawer-content om-wl-drawer__content"></div>' +
      '<div class="om-wl-drawer__foot">' +
        '<a class="btn btn-full om-wl-drawer__view" href="' + esc(wishlistUrl) + '">' + esc(t[1]) + '</a>' +
        '<button type="button" class="btn btn-full btn-border om-wl-drawer__continue" data-drawer-close>' + esc(t[2]) + '</button>' +
      '</div>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) close();
    });
    drawer.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') holdAutoClose(); });
    drawer.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && drawer.classList.contains('open')) armAutoClose(); });
    drawer.addEventListener('touchstart', holdAutoClose, { passive: true });
    drawer.addEventListener('keydown', holdAutoClose);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
    document.addEventListener('click', function (e) { if (e.target && e.target.id === 'drawer-backdrop' && drawer.classList.contains('open')) close(); });
    return drawer;
  }
  var lastFocus = null;
  /* closes by itself after 3 s (Robin 22 Oct); pointer over / touching / typing in it keeps it open */
  var autoTimer = null;
  function armAutoClose() { clearTimeout(autoTimer); autoTimer = setTimeout(close, 3000); }
  function holdAutoClose() { clearTimeout(autoTimer); }
  function close() {
    clearTimeout(autoTimer);
    if (!drawer) return;
    drawer.classList.remove('open');
    var bd = document.getElementById('drawer-backdrop');
    if (bd && !document.querySelector('.site-drawer.open')) bd.classList.remove('active');
    document.documentElement.classList.remove('om-wl-drawer-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function render(item, info, n, product) {
    var d = ensureDrawer();
    d.querySelector('#omWlDrawerTitle').textContent = t[0] + ' (' + n + ')';
    var url = product ? product.url : (item.h ? root.replace(/\/$/, '') + '/products/' + item.h : '#');
    var img = info.img || (product && product.featured_image ? sized(product.featured_image, 300) : '');
    var vendor = product ? product.vendor : '';
    var title = product ? product.title : '';
    d.querySelector('.om-wl-drawer__content').innerHTML =
      '<a class="om-wl-drawer__item" href="' + esc(url) + '">' +
        '<span class="om-wl-drawer__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="eager">' : '') + '</span>' +
        '<span class="om-wl-drawer__text">' +
          (vendor ? '<span class="om-wl-drawer__vendor">' + esc(vendor) + '</span>' : '') +
          (title ? '<span class="om-wl-drawer__title">' + esc(title) + '</span>' : '') +
          (info.price ? '<span class="om-wl-drawer__price">' + esc(info.price) + '</span>' : '') +
          '<span class="om-wl-drawer__note">' + esc(t[3]) + '</span>' +
        '</span>' +
      '</a>';
  }
  function openDrawer(item, info, n) {
    var finish = function (product) {
      render(item, info, n, product);
      lastFocus = document.activeElement;
      document.querySelectorAll('.site-drawer.open').forEach(function (o) { if (o !== drawer) o.classList.remove('open'); });
      var bd = document.getElementById('drawer-backdrop');
      if (bd) bd.classList.add('active');
      document.documentElement.classList.add('om-wl-drawer-open');
      setTimeout(function () { /* next frame, so the slide-in transition runs */
        drawer.classList.add('open');
        var c = drawer.querySelector('.site-drawer-close');
        if (c) { try { c.focus({ preventScroll: true }); } catch (e) {} }
        armAutoClose();
      }, 30);
    };
    if (!item.h || !window.fetch) { finish(null); return; }
    fetch(root.replace(/\/$/, '') + '/products/' + encodeURIComponent(item.h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(finish, function () { finish(null); });
  }
  /* ---------------- cart (product pages, Robin 22 Oct) ----------------
     After a successful "Add to cart" the product photo flies from the button to the cart icon in the
     header (which pulses), then the usual cart preview opens. Nothing changes when adding fails. */
  var cartPress = { btn: null, at: 0 };
  function rememberCart(e) {
    var b = e.target && e.target.closest && e.target.closest('.product-form__submit, .sticky-add-cart-btn');
    if (b) { cartPress.btn = b; cartPress.at = Date.now(); }
  }
  window.addEventListener('pointerdown', rememberCart, true);
  window.addEventListener('touchstart', rememberCart, { capture: true, passive: true });
  window.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') rememberCart(e); }, true);

  function visibleCartIcon() {
    var list = document.querySelectorAll('#cart-icon-bubble');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return list[i];
    }
    return null;
  }
  function flyPhoto(btn, done) {
    withHeaderIcon(visibleCartIcon, function (target) { flyPhotoTo(btn, target, done); });
  }
  function flyPhotoTo(btn, target, done) {
    var img = largestImage();
    var src = btn.getBoundingClientRect();
    if (!target || !img || src.width === 0) { done(); return; }
    var dst = target.getBoundingClientRect();
    var size = 56;
    var f = document.createElement('div');
    f.className = 'om-cart-fly';
    f.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="">';
    var sx = src.left + src.width / 2, sy = src.top + src.height / 2;
    f.style.left = (sx - size / 2) + 'px';
    f.style.top = (sy - size / 2) + 'px';
    document.body.appendChild(f);
    var dx = (dst.left + dst.width / 2) - sx, dy = (dst.top + dst.height / 2) - sy;
    var anim = f.animate([
      { transform: 'translate(0,0) scale(.6)', opacity: 0 },
      { transform: 'translate(0,-24px) scale(1.1)', opacity: 1, offset: 0.18 },
      { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.5 - 60) + 'px) scale(.9)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25)', opacity: 0.6 }
    ], { duration: 820, easing: 'cubic-bezier(.45,0,.25,1)' });
    var finished = false;
    function end() {
      if (finished) return;
      finished = true;
      f.remove();
      bump(target, 1.3);
      setTimeout(done, 140);
    }
    anim.onfinish = end;
    setTimeout(end, 1400);
  }

  /* the cart preview (Dawn cart-drawer) opens via renderContents after a successful add:
     run the flight first, then open it */
  function hookCartDrawer() {
    var CD = window.customElements && customElements.get('cart-drawer');
    if (!CD || CD.prototype.__omFly) return !!CD;
    var orig = CD.prototype.renderContents;
    if (typeof orig !== 'function') return true;
    CD.prototype.renderContents = function () {
      var self = this, args = arguments;
      var btn = cartPress.btn && Date.now() - cartPress.at < 8000 ? cartPress.btn : null;
      cartPress.btn = null;
      if (!btn || !document.querySelector('.product-form__submit')) return orig.apply(self, args);
      flyPhoto(btn, function () { orig.apply(self, args); });
    };
    CD.prototype.__omFly = true;
    return true;
  }
  if (!hookCartDrawer() && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(hookCartDrawer);
  }
})();
